import React, {useEffect} from "react";
import { useParams } from 'react-router';
import { getDirectReportReducer } from "../../Redux/Reducers";
import { directReport, downloadReport } from "../../Redux/Actions";
import {directReports} from "../../Redux/rootReducer"
import { useDispatch, useSelector } from "react-redux";




function DirectReport() {

   const { reportslug } = useParams()
   const direct_report = useSelector((state) => state.directReports);
//    const finalReport = direct_report.report;

   const {loading , direct_reports} = direct_report;
   var finalReport = direct_reports.report
//    console.log(finalReport);
//   console.log(finalReport);
//    console.log("HELLO FROM DIRECT REPORT");
   const dispatch = useDispatch();

   useEffect(() => {
    dispatch(directReport(reportslug));
   
 
  },[]);
 


   const DownloadReport = (string) => {
    
    var b64 = string;
    // console.log("bs string i want",b64)
    var bin = window.atob(b64);
    // console.log('File Size:', Math.round(bin.length / 1024), 'KB');
    // console.log('PDF Version:', bin.match(/^.PDF-([0-9.]+)/)[1]);
    // console.log('Create Date:', bin.match(/<xmp:CreateDate>(.+?)<\/xmp:CreateDate>/)[1]);
    // console.log('Modify Date:', bin.match(/<xmp:ModifyDate>(.+?)<\/xmp:ModifyDate>/)[1]);
    // console.log('Creator Tool:', bin.match(/<xmp:CreatorTool>(.+?)<\/xmp:CreatorTool>/)[1]);
    
    
    // Embed the PDF into the HTML page and show it to the user
    // var obj = document.createElement('object');
    // obj.style.width = '100%';
    // obj.style.height = '842pt';
    // obj.type = 'application/pdf';
    // obj.data = 'data:application/pdf;base64,' + b64;
    
    // document.body.appendChild(obj);
  
    // Insert a link that allows the user to download the PDF file
    var link = document.createElement('a');
    // link.innerHTML = 'Download PDF file';
    link.download = `Report.pdf`;
    link.href = 'data:application/octet-stream;base64,' + b64;
    // window.document.getElementsByClassName(".letsdownl").innerHTML=link
    link.click();
  }
const handleReport = () =>{
    if (finalReport==""){
     alert("No Reports" );
    }
    else{
       return  DownloadReport(finalReport);
    }
}
  
 
    return (
        <div>
            <h1>{reportslug}</h1>
            <h1> hello from Direct Report </h1>
            {
                loading ? "loading" :  <div> <button onClick={ handleReport}>Downlaod Report</button></div>

            }
          
        </div>
    )
}

export default {
    component: DirectReport,
  };

